import React from 'react';
import useClientPortalService, { BrandingDto, UpdateBrandingRequest } from '../Domain/clientPortalService';
import { useDataLoaderNew } from 'data-loader';
import LoadingAnimation from '../../../shared/LoadingAnimation';
import ClientPortalBrandingForm, { BrandingFormData } from './ClientPortalBrandingForm';
import { DEFAULT_THEME } from './defaultTheme';

export default function ClientPortalBrandingSection() {
  const service = useClientPortalService();
  const { data: branding, refreshData } = useDataLoaderNew(service.getBranding);

  const handleSubmit = async (formData: BrandingFormData) => {
    try {
      const request: UpdateBrandingRequest = {
        logoFileId: formData.logoFileId,
        theme: formData.theme,
      };

      const result = await service.updateBranding(request);

      refreshData();

      return mapBrandingToFormData(result);
    } catch (error) {
      console.error('Failed to update branding configuration:', error);
      throw error;
    }
  };

  const mapBrandingToFormData = (dto: BrandingDto): BrandingFormData => {
    return {
      logoFileId: dto.logoFileId,
      _logoUrl: dto._logoUrl,
      theme: dto.theme || DEFAULT_THEME,
    };
  };

  if (!branding) {
    return <LoadingAnimation />;
  }

  const formData = mapBrandingToFormData(branding);

  return <ClientPortalBrandingForm initialData={formData} onSubmit={handleSubmit} />;
}
